export default function ServiceArea() {
  const states = [
    'Virginia',
    'Maryland',
    'Washington DC',
    'Georgia',
    'Tennessee',
    'North Carolina',
    'South Carolina',
  ];

  return (
    <section className="bg-[#1A1A1A] py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Serving the Mid-Atlantic and Southeast
            </h2>
            <div className="w-24 h-1 bg-[#C5A55A] mb-8"></div>
            <p className="text-lg text-white/80 mb-10">
              With headquarters in Virginia and expanding operations across the region, we bring decades of commercial construction expertise to your community.
            </p>

            {/* States List */}
            <div className="space-y-4">
              {states.map((state, index) => (
                <div key={index} className="flex items-center">
                  <div className="w-2 h-2 bg-[#C5A55A] rounded-full mr-4"></div>
                  <span className="text-white text-base font-medium">{state}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Map Visual */}
          <div className="relative h-[500px] bg-[#2D2D2D] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/46f884d797f9120b6c6ad026cdc4112d.jpg"
              alt="Service Area Map"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/80 to-transparent"></div>

            {/* Map Overlay Info */}
            <div className="absolute bottom-8 left-8 right-8">
              <div className="bg-[#C5A55A] text-[#1A1A1A] px-6 py-4 rounded-lg">
                <p className="font-bold text-lg mb-1">Expanding Our Reach</p>
                <p className="text-sm">Now serving 7 states across the Mid-Atlantic and Southeast</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}